interface SliderProps {
  min: React.InputHTMLAttributes<HTMLInputElement>["min"];
  max: React.InputHTMLAttributes<HTMLInputElement>["max"];
  value: number;
  step: React.InputHTMLAttributes<HTMLInputElement>["step"];
  disabled?: boolean;
  onChange: (value: number) => void;
}

/**
 * # Slider
 * A simple slider controlled externally
 */
const Slider: React.FC<SliderProps> = ({
  min,
  max,
  value,
  step,
  disabled = false,
  onChange,
}) => {
  return (
    <input
      type="range"
      min={min}
      max={max}
      value={value}
      step={step}
      onChange={(e) => {
        const newValue = Number(e.currentTarget.value);
        onChange(newValue);
      }}
      disabled={disabled}
    />
  );
};

export default Slider;
